var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sd-row',{staticClass:"lpe-row legal-text"},[_c('sd-col',{attrs:{"cols":6,"cols300":12}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.getConsentText)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }